import { Link } from 'react-router-dom';
import Icon from '@components/common/Icon';
import ImageCard from '@components/common/ImageCard';
import { getDataUrl } from '@lib/utils';

const achievements = [
  {
    to: '/chess',
    icon: 'chess',
    image: getDataUrl('chess/achievements/trophies_and_medals_collage.webp'),
    title: 'Chess Excellence',
    description: '3x National Champion, National Master title, and ranked in top 0.1% on Lichess.',
    highlights: [
      'Arena Grandmaster (FIDE)',
      'Under 12 Rapid Champion',
      'Coached 50+ inmates'
    ],
    cta: 'Learn More'
  },
  {
    to: '/robotics',
    icon: 'robotics',
    image: getDataUrl('robotics/images/frc_sydney_robot_2024.webp'),
    title: 'Robotics Leadership',
    description: "Founding partner of the Philippines' first FRC team with multiple international awards.",
    highlights: [
      '15+ international competitions',
      'Led autonomous systems design',
      'Mentored 30+ students'
    ],
    cta: 'Learn More'
  },
  {
    to: '/social-impact',
    icon: 'social-impact',
    image: getDataUrl('chess/recognitions/inmate_chess_1.webp'),
    title: 'Social Impact',
    description: 'Dedicated to giving back through mentoring, fundraising, and community outreach.',
    highlights: [
      'Raised $4,000+ for tournaments',
      'Prison reform advocate',
      'Mentored 100+ students'
    ],
    cta: 'Learn More'
  },
  {
    to: '/sports',
    icon: 'badminton',
    image: getDataUrl('badminton/photos/iasas_singapore_25_badminton_team_ism.webp'),
    title: 'Badminton',
    description: 'Competitive player with experience in school and regional tournaments. Strong focus on teamwork and athletic excellence.',
    highlights: [
      'IASAS team member',
      'Regional tournaments',
      'Team leadership'
    ],
    cta: 'Learn More'
  }
];

const AchievementsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 md:px-4">
      <div className="container mx-auto max-w-7xl">
        <h2
          className="text-3xl sm:text-4xl font-heading font-bold text-center mb-8 sm:mb-12 tracking-tight"
          style={{ color: 'var(--color-heading)' }}
        >
          Key Achievements
        </h2>
        {/* Mobile: horizontal scroll, Desktop: grid */}
        <div className="md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-6 lg:gap-8 flex md:flex-none overflow-x-auto gap-4 snap-x snap-mandatory scrollbar-hide pb-4 md:pb-0 -mx-4 px-4 md:mx-0">
          {achievements.map((achievement, index) => (
            <Link key={index} to={achievement.to} className="group h-full flex-shrink-0 w-[85vw] md:w-auto snap-center">
              <div
                className="h-full flex flex-col rounded-xl border transition-all duration-200 hover:shadow-card-hover shadow-card overflow-hidden"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-card-border)'
                }}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <ImageCard
                    src={achievement.image}
                    alt={achievement.title}
                    aspectRatio="aspect-video"
                    rounded={false}
                    shadow={false}
                    className="h-full"
                  />
                </div>

                {/* Content */}
                <div className="flex-1 flex flex-col p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div
                      className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: 'var(--color-theme-2)' }}
                    >
                      <Icon name={achievement.icon} size="lg" style={{ color: 'var(--color-icon-default)' }} />
                    </div>
                    <h3
                      className="text-xl font-bold"
                      style={{ color: 'var(--color-heading)' }}
                    >
                      {achievement.title}
                    </h3>
                  </div>
                  <p
                    className="mb-4 leading-relaxed text-base"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    {achievement.description}
                  </p>
                  <ul className="text-sm space-y-2 mb-6 flex-1" style={{ color: 'var(--color-muted)' }}>
                    {achievement.highlights.map((highlight, i) => (
                      <li key={i} className="flex items-start">
                        <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                        {highlight}
                      </li>
                    ))}
                  </ul>
                  <div
                    className="font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1"
                    style={{ color: 'var(--color-link)' }}
                  >
                    {achievement.cta} →
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
